export const analyticsAttributes = {
	proactiveGeneratedAI: 1,
	userGeneratedAI: 0,
	isAIFeature: 1,
	inProductExperience: 'jsmComposer',
};
